import { useDetailsScreen } from '@/features/dashboard/bookingChanges/contexts/DetailsContext.ts';
import BookingBillPanel from '@/features/dashboard/bookingChanges/components/BookingBillPanel.tsx';

/**
 * Zakładka „Rezerwacja” — ten sam widok na ekranie uczestnika, zapisującego
 * i rezerwacji, więc trzy route'y dzielą jeden komponent. Wszystko, czego
 * potrzebuje, stoi w szkielecie ekranu: rezerwacja, tryb, filtr i akcje wiersza.
 */
const BookingBillTab = () => {
  const {
    bookingId,
    isEditing,
    onlyChanged,
    onOnlyChangedChange,
    editField,
    currentPersonId,
  } = useDetailsScreen();

  return (
    <BookingBillPanel
      bookingId={bookingId}
      isEditing={isEditing}
      onlyChanged={onlyChanged}
      onOnlyChangedChange={onOnlyChangedChange}
      onRowAction={editField.openRow}
      onAddManualLine={editField.addManualLine}
      currentPersonId={currentPersonId}
    />
  );
};

export default BookingBillTab;
